// @ts-check
import { forEach } from "lodash";

import setLineItemWithPlannerCells from "./setLineItemWithPlannerCells";

const setGroupingsWithPlannerCells = ({
  groupings,
  macroAllocations,
  allocationProjectLookup,
  isRequestor,
  groupedByDemand,
  useDeltaForBudget,
  isRealtimeFteMode = false,
  useRealtimeChangeOnly = false,
  useRealtimeFteDelta = false,
  enableDemandRequest = false,
  approvalReasons = undefined,
}) => {
  forEach(groupings, (grouping) => {
    const macroAllocationsForGrouping = macroAllocations[grouping.groupId];
    forEach(grouping.lineItems, (lineItem) => {
      setLineItemWithPlannerCells({
        lineItem,
        macroAllocations: macroAllocationsForGrouping?.[lineItem.groupId],
        isRequestor,
        allocationProjectLookup,
        approvalReasons,
        useDeltaForBudget,
        isRealtimeFteMode,
        useRealtimeChangeOnly,
        useRealtimeFteDelta,
        enableDemandRequest,
      });
    });

    setGroupingsWithPlannerCells({
      groupings: grouping.childGroupings,
      macroAllocations,
      allocationProjectLookup,
      isRequestor,
      groupedByDemand,
      approvalReasons,
      useDeltaForBudget,
      isRealtimeFteMode,
      useRealtimeChangeOnly,
      useRealtimeFteDelta,
      enableDemandRequest,
    });
  });
};

export default setGroupingsWithPlannerCells;
